import { render, staticRenderFns } from "./layoutAccountsMenu.vue?vue&type=template&id=72b5e458&"
import script from "./layoutAccountsMenu.vue?vue&type=script&lang=js&"
export * from "./layoutAccountsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b5e458')) {
      api.createRecord('72b5e458', component.options)
    } else {
      api.reload('72b5e458', component.options)
    }
    module.hot.accept("./layoutAccountsMenu.vue?vue&type=template&id=72b5e458&", function () {
      api.rerender('72b5e458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/shared/components/layout/layoutAccountsMenu.vue"
export default component.exports